/*
 * ml-klaviyo-huella.js · de dónde salió cada suscripción
 * ══════════════════════════════════════════════════════════════════════
 *
 * QUÉ RESUELVE. Los formularios de Klaviyo guardan las propiedades que se
 * les configuran y las UTM del enlace, pero NO guardan desde qué página se
 * apuntó alguien. Y las UTM solo existen si el enlace las traía: desde la
 * biografía de Instagram o desde un enlace pelado no vienen. Resultado: se
 * sabe que alguien se suscribió, no dónde estaba cuando lo hizo.
 *
 * EL CONTRATO, MEDIDO EN EL NAVEGADOR EL 23/08/2026, no sacado de un blog:
 *
 *   evento    · «klaviyoForms»
 *   destino   · WINDOW. No document. Y NO BURBUJEA.
 *   detail    · { type, formId, formVersionId, companyId, metaData }
 *   type      · «viewedStep» | «stepSubmit» | «submit»
 *   metaData  · al enviar trae los campos del formulario y «$email»
 *
 *   Lo de window es la trampa. Casi todos los ejemplos que circulan
 *   escuchan en document, y como el evento no burbujea, ahí no llega
 *   nunca: el código parece correcto, no da ningún error, y no hace nada.
 *
 * Y «$email» viene en metaData, que es lo que permite que el identify
 * caiga en el perfil correcto y no en el visitante anónimo.
 *
 * POR QUÉ EL REFERENTE SE GUARDA AL ENTRAR Y NO AL ENVIAR. En el momento
 * de enviar, «document.referrer» es la página anterior DE ESTA MISMA WEB,
 * que no dice nada: quien llegó de Instagram, miró tres fichas y luego se
 * apuntó, tendría como origen la ficha anterior. El origen de verdad solo
 * está en la primera página de la visita, así que se guarda ahí y se
 * arrastra en sessionStorage.
 *
 * sessionStorage va envuelto en try porque en navegación privada de
 * Safari puede lanzar, y perder el origen no debe romper la suscripción.
 */
(function () {
  var ENTRADA = 'mlHuellaEntrada';
  var ORIGEN = 'mlHuellaOrigen';

  function guardado(clave) {
    try { return window.sessionStorage.getItem(clave); } catch (e) { return null; }
  }
  function guardar(clave, valor) {
    try { window.sessionStorage.setItem(clave, valor); } catch (e) { /* da igual */ }
  }

  /* La primera página de la visita es la única que conoce el origen. */
  if (!guardado(ENTRADA)) {
    guardar(ENTRADA, window.location.href);
    guardar(ORIGEN, document.referrer || 'directo');
  }

  /* Klaviyo carga tarde y de forma asíncrona. Se espera a que exista, igual
     que en ml-anotado, y se deja de esperar a los cinco segundos en vez de
     quedarse dando vueltas para siempre. */
  function anotar(datos, intentos) {
    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      window.klaviyo.identify(datos);
      return;
    }
    if (window._learnq && typeof window._learnq.push === 'function') {
      window._learnq.push(['identify', datos]);
      return;
    }
    if (intentos > 20) { return; }
    window.setTimeout(function () { anotar(datos, intentos + 1); }, 250);
  }

  window.addEventListener('klaviyoForms', function (evento) {
    var d = evento.detail;
    if (!d) { return; }
    /* «stepSubmit» salta en cada paso de un formulario de varios; «submit»
       salta una vez, al final. Solo interesa el final. */
    if (d.type !== 'submit') { return; }

    var correo = d.metaData ? d.metaData.$email : null;
    if (!correo) { return; }

    /* «$append» no es un invento nuestro: klaviyo.js lo trata como clave
       especial de identify y la retira del objeto justo después de mandarlo
       —la función se llama _removeSpecialKeysPostIdentify y recorre
       «$append», «$unappend» y «$unset»; leído dentro de fender_analytics.js
       sobre el dominio real el 05/09/2026—. Con ella la propiedad se guarda
       como lista y deja de pisarse, que era el problema: quien se apuntaba
       por el pop-up y treinta segundos después por la home se quedaba solo
       con el segundo. Pasó de verdad, con una clienta.

       Los nombres en plural son nuevos a propósito. «PuntoDeRegistro» y
       «FormularioKlaviyo» son texto, los escribe también Klaviyo desde sus
       campos ocultos, y siguen diciendo el último: eso vale para segmentar
       hoy. Los plurales son el histórico.

       Y esto NO sustituye al evento. identify corre DESPUÉS del envío, así
       que se pierde si la clienta cierra la pestaña —ya hay un perfil sin
       huella por eso—. El registro completo sigue siendo «Submitted Form»,
       y por ahí van los segmentos. */
    var punto = '';
    if (d.metaData) {
      if (d.metaData.punto_de_registro) {
        punto = d.metaData.punto_de_registro;
      }
    }

    var datos = {
      $email: correo,
      UrlDeRegistro: window.location.href,
      PaginaDeEntrada: guardado(ENTRADA) || window.location.href,
      Referente: guardado(ORIGEN) || 'directo',
      FormularioKlaviyo: d.formId || '',
      $append: {
        FormulariosKlaviyo: d.formId || ''
      }
    };
    if (punto) {
      datos.UltimoPuntoDeRegistro = punto;
      datos.$append.PuntosDeRegistro = punto;
    }
    anotar(datos, 0);
  });
})();
